import { ChannelUFC, EventType, EntityType } from "@tvg/ts-types/Alerts";

export type ItemOption = {
  id: string;
  label: string;
};

export type FAQEntry = {
  title: string;
  content: string;
};

type Search = {
  inputLabel: string;
  inputPlaceholder: string;
  emptyMessage: string;
  info: string;
  resultsAmount: number;
  success: string;
  notFound: string;
};

export type MyStableConfig = {
  title: string;
  header: string;
  body: string;
  allAlerts: string;
  viewByLabel: string;
  viewByOptions?: ItemOption[];
  tabMenu?: ItemOption[];
  myStableFAQ?: {
    title: string;
    faqMessages: FAQEntry[];
  };
  myStableSearch: Search;
  emptyMessage: string;
  showEntries: string;
  confirmationModal: {
    title: string;
    description: string;
  };
  errorMessages: {
    ERR_REMOVE: string;
    ERR_UNKNOWN: string;
    ERR_FOLLOW: string;
  };
};

export type EntityRowProps = {
  entity: ChannelUFC;
  showReplays: boolean;
  showRemove: boolean;
  onModal?: boolean;
  onChange: (entity: ChannelUFC, eventType: EventType) => void;
  onRemove?: (alert: ChannelUFC) => void;
  onReplay?: (entity: ChannelUFC) => void;
};

export type MyStableEntityTableProps = {
  qaLabel?: string;
  entities: ChannelUFC[];
  totalCount: number;
  showReplays: boolean;
  showRemove: boolean;
  onModal?: boolean;
  onChange: (entitie: ChannelUFC, eventType: EventType) => void;
  deleteAlert?: (alert: ChannelUFC) => void;
  onReplay?: (entity: ChannelUFC) => void;
};

export enum AnalyticsContext {
  MANAGE = "my_stable_manage",
  SEARCH = "my_stable_search",
  ADD_TO_MODAL = "add_to_stable_modal"
}

export type MyStableEntityTypes = Exclude<EntityType, EntityType.Race>;

export type EntityResult = {
  name: string;
  dob?: string;
  entityRunnerId?: number;
};

export enum EntityIdEnum {
  Runners = "runners",
  Jockeys = "jockeys",
  Trainers = "trainers",
  Owners = "owners"
}

export interface SearchResponse {
  raceEntities: { [key in EntityIdEnum]: Array<EntityResult> };
}
